import BackOffice from "@/components/account/BackOffice";
import { PageHead } from "@/components/account/Shell";
import { ServiceRequests } from "@/components/admin/ServiceRequests";

export default function ServiceRequestsPage() {
    return (
        <BackOffice>
            <PageHead kicker="Orders" title="Service requests" testid="service-requests-head"
                sub="Machine install, repair, maintenance and training requests from the Machine Services form." />
            <div className="mt-3"><ServiceRequests /></div>
        </BackOffice>
    );
}
